exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".espacamentoConteudo {\n  line-height: 0.9; }\n\n.espacamento1 {\n  line-height: 0; }\n\n.espacamento2 {\n  line-height: 0;\n  margin-top: -10px; }\n\n.espacamento3 {\n  line-height: 0;\n  margin-top: -10px; }\n\n.etiqueta {\n  margin: 10px;\n  padding: 0;\n  border: 1px black solid;\n  height: 170mm;\n  width: 110mm;\n  outline: 2cmrgb 0, 255, 0 0, 255, 64 FEAEA solid;\n  border-style: dashed;\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/caixa/relatorio-caixa/relatorio-caixa.component.scss
// module id = ../../../../../src/app/components/caixa/relatorio-caixa/relatorio-caixa.component.scss
// module chunks = main